<template>
  <div id="contenedor-firmas-eliminar">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Firma</v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar la Firma de "{{firmaEliminar.funcionario.nombre}}"?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="eliminarFirma"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import FIRMAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/firmas/firmasPorModulo.gql';
import REMOVER_FIRMA from '@/graphql/mutations/administracion/configuracion/firmas/removerFirma.gql';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'FirmasEliminar',
  props: {
    firmaEliminar: {
      type: Object,
      required: true,
    },
    modulo: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    async eliminarFirma() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_FIRMA,
        variables: {
          id: this.firmaEliminar.id,
        },
        update: (store) => {
          const query = {
            query: FIRMAS_POR_MODULO,
            variables: {
              modulo: this.modulo,
            },
          };
          const { firmasPorModulo } = store.readQuery(query);
          const index = firmasPorModulo
            .findIndex(
              (f) => f.id === this.firmaEliminar.id,
            );

          if (index !== -1) {
            firmasPorModulo.splice(index, 1);
          }
          store.writeQuery({
            ...query,
            data: {
              firmasPorModulo,
            },
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

  },
};
</script>

<style>
</style>
